import t, { type TranslationKey } from "@ext/localization/locale/translate";
import { SearchContentChat } from "@ext/serach/components/chat/SearchContentChat";
import type { SearchStatus } from "@ext/serach/components/model/searchResponse";
import { SearchContentResults } from "@ext/serach/components/results/SearchContentResults";
import { SearchContentHelp } from "@ext/serach/components/SearchContentHelp";
import { useSearch } from "@ext/serach/components/SearchContext";
import { FeatureIcon } from "@ui-kit/Icon";
import { ScrollShadowContainer } from "@ui-kit/ScrollShadowContainer";
import { useRef } from "react";

export const SearchContent = () => {
	const state = useSearch();
	const containerRef = useRef<HTMLDivElement>(null);

	return (
		<ScrollShadowContainer className="p-2.5" ref={containerRef}>
			{state.status === "results" ? (
				state.aiEnabled === true ? (
					<SearchContentChat nodes={state.data} onLinkOpen={state.onLinkOpen} />
				) : (
					<SearchContentResults
						containerRef={containerRef}
						currentRefPath={state.currentArticleRefPath}
						focus={state.focus}
						onLinkOpen={state.onLinkOpen}
						rows={state.data}
						showCatalog={state.scope.showCatalogBreadcrumb}
					/>
				)
			) : (
				<div className="h-[18rem] flex items-center justify-center">
					<SearchPlaceholder status={state.status} />
				</div>
			)}
		</ScrollShadowContainer>
	);
};

interface SearchPlaceholderProps {
	status: SearchStatus;
}

const placeholders: Partial<Record<SearchStatus, { icon: string; text: TranslationKey }>> = {
	loading: { icon: "loader-throbber", text: "loading" },
	error: { icon: "circle-alert", text: "app.error.command-failed.title" },
	empty: { icon: "search-x", text: "search.articles-not-found" },
};

const SearchPlaceholder = (props: SearchPlaceholderProps) => {
	const placeholder = placeholders[props.status];
	if (!placeholder) return <SearchContentHelp />;

	return (
		<span className="flex flex-col items-center gap-5 text-muted font-medium text-base">
			<FeatureIcon className="rounded-full ring-0 bg-alpha-10" icon={placeholder.icon} size="2xl" />
			{t(placeholder.text)}
		</span>
	);
};
